export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-bold-9ee5090647fd84ad3aff77af9010b23e.svg";